// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2T13W","detailsBorder":"styles_detailsBorder__3wsit"};